module.exports = __webpack_public_path__ + "static/media/tnpa-vision.cca63994.png";